
import {Component, Vue} from 'vue-property-decorator';
import _ from 'lodash';
import {ElForm} from "element-ui/types/form";
import {bindTuiShui, getReceiptAllocateRecord, pageFactoryInvoice} from "@/api/invoice/index";
import {Decimal} from "decimal.js";

@Component({
  name: 'BindTuiShuiInvoice',
})
export default class BindTuiShuiInvoice extends Vue {

  private showDialog = false;
  private loading = false;
  private options = {
    title: "",
    id: "",
    factoryId: null,
    factoryName: null,
    amount: 0,
    company: null,
    taxRate: 0,
  }
  //开票资料号码	开票品名	开票数量及单位	报关合同号	开票资料金额	税率	税额	已登记金额	本次登记金额
  private tableCol = [
    {
      label: "开票资料号码",
      prop: "receiptCode",
      key: "receiptCode",
    },
    {
      label: "开票品名",
      prop: "productName",
      key: "productName",
      render: (prop, row) => {
        return row.extMap?.productName
      }
    },
    {
      label: "开票数量及单位",
      prop: "numUnit",
      key: "numUnit",
      render: (prop, row) => {
        return row.extMap?.num + row.extMap?.unit
      }
    },
    {
      label: "报关合同号",
      prop: "bookingOrderCode",
      key: "bookingOrderCode",
      render: (prop, row) => {
        return row.extMap?.bookingOrderCode
      }
    },
    {
      label: "开票资料金额",
      prop: "amount",
      key: "amount",
    },
    {
      label: "税率",
      prop: "rate",
      key: "rate",
      type: "inputNumber",
      max: 100,
      min: 0,
      check: {
        prefix: "list",
        rules: [
          {
            required: true,
            message: '请输入税率',
            trigger: 'blur'
          },
        ]
      }
    },
    {
      label: "税额",
      prop: "rateAmount",
      key: "rateAmount",
      render: (prop, row) => {
        return row.extMap?.rateAmount
      }
    },
    {
      label: "已登记金额",
      prop: "totalAllocateAmount",
      key: "totalAllocateAmount",
    },
    {
      label: "本次分配金额",
      prop: "allocateAmount",
      key: "allocateAmount",
      type: "inputNumber",
      maxProp: "maxProp",
      width: 120,
      precision: 4,
      check: {
        prefix: "list",
        rules: [
          {
            required: true,
            message: '请输入本次分配金额',
            trigger: 'blur'
          },
          // 不能小于等于0
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                callback(new Error('不能小于等于0'));
              } else {
                callback();
              }
            }
          }
        ]
      }
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "移除",
          type: "delete",
          code: "",
          click: "handleRemove",
        },
        // {
        //   name: "修改金额",
        //   code: "",
        //   click: "handleUpdate",
        // }
      ],
      width: 120,
    },
  ]
  private table = {
    list: [] as any[],
  };

  private selectLoading = false;
  private selectInvoice = null;
  private invoiceOptions = [];
  private selectPage = {
    pageNumber: 1,
    pageSize: 20,
    pagerCount: 5,
    total: 0,
  };
  private selectQuery = ''

  public remoteMethod = _.debounce(this.remoteMethod0, 1000);

  public remoteMethod0(query) {
    this.selectLoading = true;
    // 搜索改变，重置页码
    if (this.selectQuery != query) {
      this.selectPage.pageNumber = 1;
      this.selectQuery = query;
    }
    const param = {
      code: this.selectQuery,
      factoryId: this.options.factoryId,
      company: this.options.company,
    };
    const page = {...this.selectPage};
    pageFactoryInvoice(param, page)
        .then(res => {
          const content = res.content
          this.invoiceOptions = content.filter(item => {
            return this.table.list.find(i => i.receiptId === item.id) === undefined
          }).map(item => {
            return {
              id: item.id,
              receiptId: item.id,
              label: `${item.contractCode} ${item.declarationDescription} | 未分配金额 ${item.unAllocateAmount}元`,
              receiptCode: item.contractCode,
              supplierId: this.options.factoryId,
              type: "FACTORY_INVOICE",
              amount: item.finalInvoiceAmount,
              totalAllocateAmount: new Decimal(item.finalInvoiceAmount).sub(new Decimal(item.unAllocateAmount)).toNumber(),
              allocateAmount: item.unAllocateAmount,
              maxProp: item.unAllocateAmount,
              rate: this.options.taxRate * 100,
              extMap: {
                num: item.settlementQuantity,
                unit: item.invoiceUnit,
                productName: item.declarationDescription,
                hqPackingCode: item.hqPackingListCodes?.join(","),
                purchaseOrderCode: item.purchaseOrderCodes?.join(","),
                bookingOrderCode: item.bookingOrderCode,
                rate: this.options.taxRate * 100,
                rateAmount: new Decimal(item.finalInvoiceAmount)
                    .div((new Decimal(1).add(new Decimal(this.options.taxRate))))
                    .mul(new Decimal(this.options.taxRate)).toFixed(2),
              }
            }
          })
          this.selectPage.total = res.total
        })
        .finally(() => this.selectLoading = false)
  }

  public changeSelectPage(val) {
    this.selectPage.pageNumber = val
    this.remoteMethod(this.selectQuery)
  }

  private async getList() {
    getReceiptAllocateRecord({id: this.options.id})
        .then(({data}) => {
          this.table.list = (data as any[]).map(item => {
            item.rate = item.extMap.rate;
            item.maxProp = new Decimal(item.amount).add(new Decimal(item.allocateAmount))
                .sub(new Decimal(item.totalAllocateAmount)).toNumber();
            return item;
          })
          this.loading = false;
        })
  }

  public handleAddInvoice() {
    if (this.table.list.find(item => item.receiptId == this.selectInvoice) === undefined) {
      const obj = Object.assign({}, this.invoiceOptions.find(item => item.id === this.selectInvoice))
      if (obj) {
        let totalAllocateAmount = new Decimal(0);
        this.table.list.forEach(i => {
          totalAllocateAmount = totalAllocateAmount.add(new Decimal(i.allocateAmount))
        })
        obj.allocateAmount = Math.min(obj.allocateAmount, new Decimal(this.options.amount).sub(totalAllocateAmount).toNumber())
        this.table.list.push(obj)
      }
    }
  }

  public handleRemove({row}) {
    this.table.list = this.table.list.filter(item => item.id !== row.id)
  }

  private confirmLoading = false;

  public async handleSubmit() {
    this.confirmLoading = true;
    (this.$refs.form as ElForm).validate(async (valid) => {
      try {
        if (valid) {
          await bindTuiShui({
            invoiceId: this.options.id,
            allocateReceipts: this.table.list,
          });
          this.showDialog = false;
          this.$emit("confirm")
        }
      } finally {
        this.confirmLoading = false
      }
    });
  }

  public handleInputChange({val, row, column}) {
    const data = row.row;
    if (column.key === 'rate') {
      data.extMap.rate = val;
      data.extMap.rateAmount = new Decimal(data.amount)
          .dividedBy(new Decimal(1).plus(new Decimal(val).div(100)))
          .mul(new Decimal(val)).div(100).toFixed(2);
      return;
    }
  }


  public async openDialog(obj, options) {
    this.options = options;
    this.options.id = obj.id;
    this.options.factoryId = obj.factoryId;
    this.options.factoryName = obj.factoryName;
    this.options.amount = obj.amount;
    this.options.company = obj.company;
    // 税率放大为百分比形式
    this.options.taxRate = obj.taxRate;
    this.showDialog = true;
    this.getList()
    this.reset()
  }

  public reset() {
    this.invoiceOptions = []
    this.selectInvoice = null;
  }
}
